import { FormControl, FormGroup } from '@angular/forms';
import { ICommunication, IFormGroup } from '@shared-libs/interfaces';

export class CommunicationFormFactory {
	public static create(defaultOption: boolean = true): IFormGroup<ICommunication> {
		return new FormGroup({
			user: new FormControl(defaultOption),
			client: new FormControl(defaultOption),
			employee: new FormControl(defaultOption),
		}) as IFormGroup;
	}
}
